<template>
  <div id="home">
    <Header :content="de.headline" />
    <!-- <Video /> -->
    <Video />
    <!-- <Video3 /> -->
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
// import Video from "@/components/Video.vue";
import Video from "@/components/Video.vue";
// import Video3 from "@/components/Video3.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    Video,
    Footer,
  },
  data() {
    return {
      de: {
        headline:
          "<strong>The Pool</strong> is a Zurich-based strategic and creative office,<br>supplier of <strong>contemporary culture</strong> for luxury, finance, and tech.",
      },
      trigger: null,
      video: null,
    };
  },
};
</script>

<style lang="scss">
h1 {
  color: white;
  margin-bottom: 3rem;
  margin-top: 3rem;
}
#home {
  // display: grid;
  width: 100vw;
  height: 100vh;
  scroll-snap-type: mandatory;
  scroll-snap-type: y mandatory;
  scroll-snap-points-y: repeat(100vh);
  // position: relative;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: -1;

  @-moz-document url-prefix() {
    scroll-snap-type: y proximity;
  }

  header,
  section,
  footer {
    scroll-snap-align: start;
    scroll-snap-stop: normal;
  }
  // footer {
  //   scroll-snap-align: end;
  //   scroll-snap-stop: normal;
  // }
}
</style>
